import {HTTPError} from "platformed-client";

export function displayHumanReadableError(e: unknown): string | undefined {
  if (!e) {
    return undefined;
  }

  if (e instanceof HTTPError) {
    return e.display();
  }

  return e.toString();
}
